module.exports = __webpack_public_path__ + "static_portal/img/bg4-poster.8160a9fc.jpg";